import { render } from "./App.vue?vue&type=template&id=5c3e1546"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5c3e1546&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/vueproject/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__